export default "__VITE_ASSET__CS8djjX5__"